module.exports = __webpack_public_path__ + "img/0.43ca3d19.png";